/* ACKNOWLEDGEMENT
 * ref: https://stackoverflow.com/a/61719846
 */
import { useEffect, useRef, useState } from 'react';
import { throttle } from '@zg-rentals/zdash';

const BELOW = 'below';
const ABOVE = 'above';

/**
 * Check if an element is in viewport

 * @param {number} offset - Number of pixels up to the observable element from the top
 * @param {number} throttleMilliseconds - Throttle observable listener, in ms
 */
const useVisibility = (offset = 0, throttleMilliseconds = 100, intersectMode: typeof BELOW | typeof ABOVE = BELOW) => {
  const [isVisible, setIsVisible] = useState(false);
  const currentElement = useRef<HTMLElement>();

  useEffect(() => {
    checkVisibility();

    document.addEventListener('scroll', checkVisibility);
    // eslint-disable-next-line constellation/voice-and-tone
    document.addEventListener('click', checkVisibility);

    return () => {
      document.removeEventListener('scroll', checkVisibility);
      // eslint-disable-next-line constellation/voice-and-tone
      document.removeEventListener('click', checkVisibility);
    };
  }, []);

  const checkVisibility = throttle(() => {
    if (!currentElement.current) {
      setIsVisible(false);
      return;
    }

    const { top } = currentElement.current.getBoundingClientRect();

    /*
     * above = top + offset >= 0
     * below = top - offset <= window.innerHeight
     * setIsVisible(above && below);
     */
    setIsVisible(intersectMode === BELOW ? top - offset <= window.innerHeight : top + offset >= 0);
  }, throttleMilliseconds);

  return [isVisible, currentElement];
};

export default useVisibility;
